import LocalizedStrings from 'localized-strings';

import { ReasonInitialStep } from '../../constants';

const locales = new LocalizedStrings({
  en: {
    subtitle:
      'Before you go, could you tell us more? Your opinion is important for us to improve.',
    title: 'We’re sorry to see you go…',
    [ReasonInitialStep.StopActivity]: 'I’m closing down my business',
    [ReasonInitialStep.Satisfied]: 'I’m happy with Shine, but…',
    [ReasonInitialStep.Unsatisfied]: 'I’m unhappy with Shine because…',
    [ReasonInitialStep.Other]: 'Other',
  },
  fr: {
    subtitle:
      'Avant de nous quitter, pourriez-vous nous en dire plus ? Votre avis est important pour nous permettre de nous améliorer.',
    title: 'Quel dommage de vous voir partir…',
    [ReasonInitialStep.StopActivity]: 'Je cesse mon activité',
    [ReasonInitialStep.Satisfied]: 'Je suis satisfait·e de Shine mais…',
    [ReasonInitialStep.Unsatisfied]: 'Je suis mécontent·e de Shine car…',
    [ReasonInitialStep.Other]: 'Autre',
  },
});

export default locales;
